var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-page-edit',{attrs:{"autoValidate":""},on:{"init":_vm.handleInit,"submit":_vm.handleSubmit}},[_c('Details',{attrs:{"receiveValidation":_vm.receiveValidation,"userData":_vm.userData}}),_c('Receive',{attrs:{"access":_vm.access,"receiveData":_vm.receiveData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }